import type { GridColDef, GridColumnVisibilityModel, GridValidRowModel } from '@mui/x-data-grid-pro'

import type { ListColumnSetting, ListStructure } from './use-list-service/types'

export function mapVisibilityModelToListColumns(visibilityModel: GridColumnVisibilityModel): string {
  const columns = Object.entries(visibilityModel).reduce<string[]>((columns, [column, visible]) => {
    if (visible) columns.push(column)

    return columns
  }, [])

  // Need to sort here so the order of fields for the request stays the same
  // independent of the ordering of the keys in the object.
  return columns.sort().join(',')
}

export function mapListColumnSettingsToColumnVisibilityModel(columns: ListColumnSetting[]): GridColumnVisibilityModel {
  return columns.reduce<GridColumnVisibilityModel>((visibilityModel, column) => {
    visibilityModel[column.Name] = true

    return visibilityModel
  }, {})
}

export function combineColumnVisibilityModelAndStructure(
  columnVisibilityModel: GridColumnVisibilityModel,
  structure: ListStructure
): GridColumnVisibilityModel {
  const structureVisibilityModel = Object.entries(structure).reduce<GridColumnVisibilityModel>(
    (structureVisibilityModel, [entityName, propertiesObject]) => {
      Object.keys(propertiesObject).forEach(propertyName => {
        const columnKey = `${entityName}.${propertyName}`
        if (columnKey in columnVisibilityModel) return
        structureVisibilityModel[columnKey] = false
      })

      return structureVisibilityModel
    },
    {}
  )

  return { ...columnVisibilityModel, ...structureVisibilityModel }
}

export function sortColumnVisibilityModelByColumnOrder<T extends GridValidRowModel>(
  columnVisibilityModel: GridColumnVisibilityModel,
  columns: GridColDef<T>[]
): GridColumnVisibilityModel {
  const sortedColumnVisibilityModel: GridColumnVisibilityModel = {}
  return columns.reduce((sortedColumnVisibilityModel, column) => {
    sortedColumnVisibilityModel[column.field] = columnVisibilityModel[column.field]

    return sortedColumnVisibilityModel
  }, sortedColumnVisibilityModel)
}

export function shouldCreateAllColumnsVisibleColumnVisibilityModel(
  columnVisibilityModel: GridColumnVisibilityModel
): columnVisibilityModel is {} {
  return Object.keys(columnVisibilityModel).length === 0
}

export function createAllColumnsVisibleColumnVisibilityModel(columns: GridColDef[]): GridColumnVisibilityModel {
  return columns.reduce<GridColumnVisibilityModel>((columnVisibilityModel, column) => {
    columnVisibilityModel[column.field] = true
    return columnVisibilityModel
  }, {})
}
